import { Component } from 'global/interfaces/component.interface';
import ControllerBase from 'global/js/ControllerBase';
import { IAlert, MoleculeAlertProps } from '../m-alert/m-alert.data';
import { PostFormResponseFailure, PostFormResponseSuccess } from './m-fhw-contact-form.types';


const templateAlert = require('components/molecules/m-alert/m-alert.template.twig') as (
	data: Component<MoleculeAlertProps>,
) => string;

export default class ControllerFhwContactForm extends ControllerBase<ComponentRefs> {
	private form: HTMLFormElement;
	private formAlert: HTMLDivElement;
	private formAlertRef: ComponentRefs['formAlert'] = 'formAlert';
	private submitButton: HTMLInputElement;
	private submitButtonRef: ComponentRefs['submitButton'] = 'submitButton';

	constructor(element: HTMLElement) {
		super(element);

		this.form = this.$references.form as HTMLFormElement;
		this.formAlert = this.$references.formAlert as HTMLDivElement;
		this.submitButton = this.$references.submitButton as HTMLInputElement;
		this.init();
	}

	private init() {
		this.form && this.form.addEventListener('submit', (e) => this.handleFormPost(e));
	}

	private handleFormPost(e: Event): void {
		e.preventDefault();

		// reset previous submission errors
		this.clearAlert();

		// const formData = new FormData(this.form);
		const formData = new FormData(e.target as HTMLFormElement);
		// const formData = JSON.stringify({ foo: 'bar' });
		const endpoint = new URL((e.target as HTMLFormElement).action || '');

		// post the data
		fetch(endpoint.toString(), {
			method: 'POST',
			credentials: 'same-origin',
			body: formData
		})
		.then((resp) => {
			return resp.json();
		})
		.then((resp: PostFormResponseSuccess) => {
			// success
			this.showAlertMessage(resp?.message || '', 'success');
			this.disableSubmitButton();
		}).catch((error: PostFormResponseFailure) => {
			// fail
			this.showAlertMessage(error && error.message || '', 'danger');
		});
	}

	/**
	 * show the response alert in the DOM
	 * @param  {string} message
	 * @param  {IAlert['type']} type
	 * @returns void
	 */
	private showAlertMessage(message: string, type: IAlert['type']): void {

		const newAlert: MoleculeAlertProps = {
			items: [
				{
					message,
					type,
				}
			]
		};

		// build new alert HTML
		const html = templateAlert({
			data: newAlert,
		});

		// render onto page above submit button
		this.domUtils.renderDomElement(this.formAlertRef, html);
	}

	private clearAlert(): void {
		this.domUtils.renderDomElement(this.formAlertRef, '');
	}

	private disableSubmitButton(): void {
		this.submitButton && this.submitButton.setAttribute('disabled', 'true');
	}
}

interface ComponentRefs {
	form: 'form',
	formAlert: 'formAlert',
	submitButton: 'submitButton',
}
